import { PrintCardContentViewModel } from './print-card-content-view-model';
import type { CardData } from '../../../../../../models/print-cards/card-data';
import { Injectable } from '@angular/core';
import type { PrintCardColumnViewModel } from '../../../../../display/components/menus/product-menu/building-blocks/menu-section/product-section/section-column-view-models/print-card-column-view-model';

@Injectable()
export abstract class GenericPrintCardContentViewModel extends PrintCardContentViewModel {
  protected override getExpandedGridSizeHelper(
    cardData: CardData,
    columnVM: PrintCardColumnViewModel,
    removeSpacing: boolean = true,
    upperCaseUnits: boolean = true
  ): string {
    const variant = columnVM?.variant;
    const size = cardData?.getGridQuantityAndSizeString(variant);
    const split = size?.split(' ');
    const lastIndex = split?.length - 1;
    if (lastIndex > -1 && upperCaseUnits) split[lastIndex] = split[lastIndex]?.toUpperCase();
    const splitLowerCased = split?.map(it => it?.toLowerCase());
    if (splitLowerCased?.includes('capsule') || splitLowerCased?.includes('capsules')) return split?.join(' ');
    return split?.join(removeSpacing ? '' : ' ');
  }
}
